import React from 'react'
import {
  BulkDeleteButton,
  Datagrid,
  Filter,
  FunctionField,
  List,
  SearchInput,
  TextField,
} from 'react-admin'
import ListPagination from '../../components/ListPagination'
import RequiredChain from '../../components/RequiredChain'
import { formatReal } from '../../lib'

const Filters = props => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
)

const BulkActionButtons = () => (
  <BulkDeleteButton label="Inativar" />
)

const list = ({ ...props }) => {
  return (
    <RequiredChain>
      <List
        {...props}
        perPage={25}
        hasCreate
        pagination={<ListPagination />}
        exporter={false}
        title="Produtos em dinheiro"
        filters={<Filters />}
      >
        <Datagrid rowClick="edit" bulkActionButtons={<BulkActionButtons />}>
          <TextField source="name" label="Nome" />
          <FunctionField
            label="Valor em reais"
            textAlign="center"
            render={record => {
              // cashValue é a fonte da verdade; produto legado guardava o valor no próprio nome.
              const value = record?.cashValue ?? record?.name
              const numeric = Number(String(value ?? '').replace(',', '.'))
              return Number.isFinite(numeric) ? formatReal(numeric) : '—'
            }}
          />
          <TextField source="description" label="Descrição" />
        </Datagrid>
      </List>
    </RequiredChain>
  )
}

export default list
